import * as React from 'react';
import CdnImage from '../../../../../../CdnImage';
const CardExtraIcon = ({ type, iconUrl }) => {
    const iconName = type === 'loyalty' ? 'loyalty2' : type;
    const iconPath = iconUrl || `CardExtra/${iconName}.svg`;
    const iconFallbackPath = `https://cdn.websky.aero/content/frontend/images/ZZ/${iconPath}`;
    return React.createElement(CdnImage, { path: iconPath, fallbackUrl: iconFallbackPath });
};
export default CardExtraIcon;
